import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MultiImagePreviewComponent } from "../../../../../../shared/content/components/multi-image-preview/multi-image-preview.component";
import { PublicationTemplatePreview } from "../../../components/publication-template-preview/publication-template-preview";
import { PublicationTemplateType } from "../../../data/entities/publication-templates.entity";
import { FacebookPost } from "../../../domain/models/facebook-post";

@Component({
  standalone: true,
  selector: "app-facebook-post-preview",
  templateUrl: "./facebook-post-preview.component.html",
  styleUrls: ["./facebook-post-preview.component.scss"],
  imports: [TranslateModule, MultiImagePreviewComponent],
})
export class FacebookPostPreviewComponent extends PublicationTemplatePreview<PublicationTemplateType.FacebookPost> {
  protected get imageUrls() {
    return ((this.data as Partial<FacebookPost>).images ?? []).map(
      (image) => image.link,
    );
  }
}
